export default (item) => ({
  id: item.id,
  speed: item.speed || 0,
})
